import { useDefaultServiceGetV1EquitiesBySyms } from 'gen/stream-api/queries';
import { dayjs, ET, prevBusinessDayOpenMarket } from 'util/shared';

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

// Null when the previous session's close isn't available.
const useDailyChangeFraction = (
  symbol: string,
  spot: number,
  tradeDate: string,
): number | null => {
  // Noon ET: the holiday check formats the date in the browser's zone.
  const prevTradeDate = ISO_DATE.test(tradeDate)
    ? prevBusinessDayOpenMarket(dayjs.tz(`${tradeDate} 12:00`, ET)).format(
        'YYYY-MM-DD',
      )
    : undefined;
  const { data } = useDefaultServiceGetV1EquitiesBySyms(
    { syms: [symbol], date: prevTradeDate },
    undefined,
    { enabled: prevTradeDate != null },
  );

  const row = data?.[symbol];
  // The endpoint falls back to an earlier date when it has none for prevTradeDate.
  if (
    row?.upx == null ||
    row.upx <= 0 ||
    row.trade_date == null ||
    dayjs.utc(row.trade_date).format('YYYY-MM-DD') !== prevTradeDate
  ) {
    return null;
  }
  return (spot - row.upx) / row.upx;
};

export default useDailyChangeFraction;
